export default "/images/elephante.png";